import {
  Box,
  Flex,
  Icon,
  Progress,
  useColorModeValue
} from '@chakra-ui/react';
import { IconType } from 'react-icons';

interface ProgressBarProps {
  progress: number;
  icon: IconType;
  dynamicColor?: boolean;
  staticColor?: string;
  height?: number;
}

export default function ProgressBar({
  progress,
  icon,
  dynamicColor = false,
  staticColor = 'blue.500',
  height = 4,
}: ProgressBarProps) {
  const getScheme = (p: number): string => {
    if (p < 30) return 'red';
    if (p < 60) return 'orange';
    return 'green';
  };

  const getDynamicColor = (progress: number): string => {
    if (progress < 20) return 'red.500';
    if (progress < 30) return 'red.400';
    if (progress < 40) return 'orange.400';
    if (progress < 50) return 'orange.300';
    if (progress < 60) return 'orange.200';
    if (progress < 70) return 'green.300';
    if (progress < 80) return 'green.400';
    if (progress < 90) return 'green.500';
    if (progress < 99) return 'green.600';
    return 'green.700';
  };

  const progressColor = dynamicColor ? getDynamicColor(progress) : staticColor;
  const circleBg = useColorModeValue(`${progressColor}`, `${progressColor}`);

  return (
    <Flex align="center" position="relative" width="100%">
      <Progress
        value={progress}
        flex="1"
        height={height}
        borderRadius="full"
        colorScheme={getScheme(progress)}
        display={'flex'}
        justifyContent={'flex-start'}
      />
      <Box
        position="absolute"
        right="0"
        transform="translateX(20%)"
        w={height * 2}
        h={height * 2}
        borderRadius="full"
        bg={circleBg}
        display="flex"
        alignItems="center"
        justifyContent="center"
        zIndex={1}
      >
        <Icon as={icon} color="white" boxSize={height} />
      </Box>
    </Flex>
  );
}
